<template>
    <div v-if="!loadingPage" class="pb-2">
        <div class="d-flex justify-content-between align-items-center">
            <h3 class="text-primary mb-2">انبارها</h3>
            <div v-if="isAdminIdentityVerified" class="d-flex justify-content-md-end justify-content-center mb-2">
                <b-button @click="showModalCreate" variant="primary" class="px-3">
                    ایجاد
                </b-button>
            </div>
        </div>
        <div v-if="isAdminIdentityVerified">
            <b-card v-if="warehouses.length" class="p-0" no-body>
                <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                    <b-table responsive :items="warehouses" :fields="fields" class="mb-0" striped>
                        <template #cell(edit)="data">
                            <feather-icon @click="showModalEdit(data.item)" size="18" icon="EditIcon"
                                class="pointer text-info" color="#8d88a3" />
                        </template>
                        <template #cell(lastModifiedBy)="data">
                            {{ `${data.item.lastModifiedBy.firstName} ${data.item.lastModifiedBy.lastName}` }}
                        </template>
                        <template #cell(details)="data">
                            <b-spinner v-if="loadingbuttons[data.index]" variant="info" small></b-spinner>
                            <feather-icon v-else @click="showDetails(data.item.id, data.index)" size="20"
                                icon="InfoIcon" class="pointer text-info" color="#8d88a3" />
                        </template>
                        <template #cell(createdAt)="data">
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new
                                    Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                        2).join(":") }}
                            </span>
                        </template>
                        <template #cell(lastModifiedAt)="data">
                            <span>
                                {{ new Date(data.item.lastModifiedAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new
                                    Date(data.item.lastModifiedAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                        2).join(":") }}
                            </span>
                        </template>
                    </b-table>
                </b-overlay>
            </b-card>
            <b-card v-else class="text-center py-5">
                موردی وجود ندارد
            </b-card>
            <b-pagination align="center" @input="getWarehousingWarehouses" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
        </div>

        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>

        <!------------------------------- modal create and edit ------------------------------->
        <b-modal id="warehousing-warehouses" :title="`${warehouseMode}`" centered :hide-footer="true"
            title-class="font-weight-bolder" size="md">
            <div class="p-1">
                <validation-observer ref="warehousingWarehousesValidation">
                    <b-form @submit.prevent>

                        <!-- name -->
                        <b-form-group label="نام" label-for="nameId" class="text-center">
                            <validation-provider #default="{ errors }" name="نام" rules="required">
                                <b-form-input autocomplete="off" dir="rtl" id="nameId" v-model="form.name" name="name"
                                    class="text-center user-select-none" :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- description -->
                        <b-form-group label="توضیحات" label-for="descriptionId" class="text-center">
                            <b-form-textarea rows="2" no-resize autocomplete="off" dir="rtl" id="descriptionId"
                                v-model="form.description" name="description"></b-form-textarea>
                        </b-form-group>

                        <b-button type="submit" variant="primary" @click="managementWarehouses"
                            :disabled="loadingButton"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                            <span>{{ warehouseMode }}</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>

        <!------------------------------- modal warehousing warehouses detail ------------------------------->
        <b-modal id="warehousing-warehouses-detail" title="جزئیات انبار" centered :hide-footer="true"
            title-class="font-weight-bolder" size="lg" body-class="p-0">
            <div class="pb-2 pt-1 px-2">
                <h5 class="text-info font-weight-bolder">نام</h5>
                <h4 class="mb-0">{{ warehouseDetails.name }}</h4>
                <div v-if="warehouseDetails.description" class="mt-2">
                    <h5 class="text-info font-weight-bolder">توضیحات</h5>
                    <h5 class="mb-0">{{ warehouseDetails.description }}</h5>
                </div>
                <h5 v-if="warehouseDetails.rawMaterials.length" class="text-info font-weight-bolder mt-2">
                    مواد اولیه (کالا)
                </h5>
                <b-table v-if="warehouseDetails.rawMaterials.length" responsive :items="warehouseDetails.rawMaterials"
                    :fields="fieldsRawMaterials" class="mb-0 mt-1" hover bordered>
                    <template #cell(unit)="data">
                        {{ unit_management(data.item.unit) }}
                    </template>
                    <template #cell(currentQuantity)="data">
                        <span v-b-popover.hover.top="data.item.currentQuantity"
                            :title="data.item.unit == 1 ? 'گرم' : data.item.unit == 2 ? 'میلی‌لیتر' : 'عدد'"
                            class="text-info pointer">
                            {{
                                [1, 2].includes(data.item.unit) ? (data.item.currentQuantity / 1000) :
                                    data.item.currentQuantity
                            }}
                        </span>
                    </template>
                </b-table>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, VBPopover, BForm, BFormRadio, BFormTextarea, BTable, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BMediaBody, BFormInput, BFormGroup, BSpinner, BBadge } from 'bootstrap-vue';
import { storeService } from '@core/services';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BFormTextarea,
        BBadge
    },
    directives: {
        'b-popover': VBPopover,
    },
    computed: {
        unit_management() {
            return (status) => {
                if (status == 1) {
                    return 'کیلوگرم'
                }
                if (status == 2) {
                    return 'لیتر'
                }
                if (status == 3) {
                    return 'عدد'
                }
            }
        },
    },
    mixins: [accessHandling],
    data() {
        return {
            required,
            loadingPage: true,
            loading: false,
            loadingbuttons: [],
            loadingButton: false,
            isAdminIdentityVerified: false,
            warehouses: [],
            warehouseDetails: {
                rawMaterials: []
            },
            fieldsRawMaterials: [
                {
                    key: 'name',
                    label: 'نام',
                },
                {
                    key: 'unit',
                    label: 'واحد اندازه گیری',
                },
                {
                    key: 'currentQuantity',
                    label: 'موجودی',
                },
            ],
            fields: [
                {
                    key: 'name',
                    label: 'نام',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ ایجاد',
                },
                {
                    key: 'lastModifiedAt',
                    label: 'تاریخ آخرین ویرایش',
                },
                {
                    key: 'lastModifiedBy',
                    label: 'ایجاد یا ویرایش‌ کننده',
                },
                {
                    key: 'details',
                    label: 'جزئیات',
                },
                {
                    key: 'edit',
                    label: 'ویرایش',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null
            },
            storeId: null,
            form: {
                name: null,
                description: null,
            },
            warehouseMode: null,
            warehouseId: null,
        }
    },
    methods: {
        showDetails(id, index) {
            this.$set(this.loadingbuttons, index, true);
            storeService.getwarehousingWarehousesById(this.storeId, id).then(({ data }) => {
                this.warehouseDetails = data
                this.$set(this.loadingbuttons, index, false);
                this.$bvModal.show('warehousing-warehouses-detail')
            })
                .catch((err) => {
                    this.$set(this.loadingbuttons, index, false);
                });
        },
        managementWarehouses() {
            if (this.warehouseMode == 'ایجاد') {
                this.createWarehousingWarehouses()
            }
            if (this.warehouseMode == 'ویرایش') {
                this.editWarehousingWarehouses()
            }
        },
        showModalEdit(item) {
            if (this.accessHandling('employee', 'warehouses_manage')) {
                this.warehouseMode = 'ویرایش'
                this.warehouseId = item.id
                this.form.name = item.name
                this.form.description = item.description
                this.$bvModal.show('warehousing-warehouses')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        showModalCreate() {
            if (this.accessHandling('employee', 'warehouses_manage')) {
                this.warehouseMode = 'ایجاد'
                this.form.name = null
                this.form.description = null
                this.$bvModal.show('warehousing-warehouses')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        editWarehousingWarehouses() {
            this.$refs.warehousingWarehousesValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    storeService.editWarehousingWarehouses(this.storeId, this.warehouseId, this.form).then(({ data }) => {
                        this.$refs.warehousingWarehousesValidation.reset();
                        this.$notif({ type: 'success', title: 'انبار با موفقیت ویرایش شد' });
                        this.$bvModal.hide('warehousing-warehouses')
                        this.getWarehousingWarehouses()
                    })
                        .finally(() => {
                            this.loadingButton = false
                        });
                }
            });
        },
        createWarehousingWarehouses() {
            this.$refs.warehousingWarehousesValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    storeService.warehousingWarehouses(this.storeId, this.form).then(({ data }) => {
                        this.$refs.warehousingWarehousesValidation.reset();
                        this.$notif({ type: 'success', title: 'انبار با موفقیت ایجاد شد' });
                        this.$bvModal.hide('warehousing-warehouses')
                        this.getWarehousingWarehouses()
                    })
                        .finally(() => {
                            this.loadingButton = false
                        });
                }
            });
        },
        getCompletionStatus() {
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified
                if (this.isAdminIdentityVerified) {
                    this.getWarehousingWarehouses();
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
        getWarehousingWarehouses() {
            this.loading = true
            this.loadingbuttons = []
            storeService.getWarehousingWarehouses(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.warehouses = data.items
                    if (this.warehouses.length) {
                        this.warehouses.forEach(obj => {
                            this.loadingbuttons.push(false)
                        });
                    }
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.warehouses = data.items
                        if (this.warehouses.length) {
                            this.warehouses.forEach(obj => {
                                this.loadingbuttons.push(false)
                            });
                        }
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getCompletionStatus()
    },
};
</script>